import axios from "axios";
import React, { useEffect, useState } from "react";
import "@fontsource/roboto/400.css";
//import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
//import Link from "@mui/material/Link";
//import IconButton from "@mui/material/IconButton";
//import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';


function NuevoPedido() {
  //const [username, setUsername] = useState("");
  //const [email, setEmail] = useState("");
 //const [password, setPassword] = useState("");
 
  const [apiResponse, setApiResponse] = useState("");
  const [nombreOrigen, setnombreOrigen] = useState("");
  const [contactoOrigen, setcontactoOrigen] = useState("");
  const [direccionOrigen, setdireccionOrigen] = useState("");
  const [emailOrigen, setemailOrigen] = useState("");
  const [telefonoOrigen, settelefonoOrigen] = useState("");
  const [nombreDestino, setnombreDestino] = useState("");
  const [contactoDestino, setcontactoDestino] = useState("");
  const [direccionDestino, setdireccionDestino] = useState("");
  const [emailDestino, setemailDestino] = useState("");
  const [telefonoDestino, settelefonoDestino] = useState("");
  //const [newpedido, setNewPedidos] = useState([]);
  
  const [calleDestino, setcalleDestino] = useState("");
  const [numeroDestino, setnumeroDestino] = useState("");
  const [cpDestino, setcpDestino] = useState("");
  const [coloniaDestino, setcoloniaDestino] = useState("");
  const [alcaldiaDestino, setalcaldiaDestino] = useState("");
  const [referenciasDestino, setreferenciasDestino] = useState("");
  const [calleOrigen, setcalleOrigen] = useState("");
  const [numeroOrigen, setnumeroOrigen] = useState("");
  const [cpOrigen, setcpOrigen] = useState("");
  const [coloniaOrigen, setcoloniaOrigen] = useState("");
  const [alcaldiaOrigen, setalcaldiaOrigen] = useState("");
  const [referenciasOrigen, setreferenciasOrigen] = useState("");
  const [proteccion, setproteccion] = useState("");
  const [valor, setvalor] = useState("");
  const [altura, setaltura] = useState("");
  const [ancho, setancho] = useState("");
  const [largo, setlargo] = useState("");
  const [peso, setpeso] = useState("");
  const [proyecto, setproyecto] = useState("");
  const [sitio, setsitio] = useState("");

  const loggedIn = sessionStorage.getItem("loggedIn");
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const clienteid = userData?.clienteid;
  const navigate = useNavigate();
  const [apiResponseEmp, setApiResponseEmp] = useState("");
  const [empresa, setEmpresa] = useState([]);
  


//Google Maps
  

//Google Maps

    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
        }else{
            getEmpresas();
        }
    }, []);


  const handlenombreOrigenChange = (event) => {
    setnombreOrigen(event.target.value);
  };

  const handlecontactoOrigenChange = (event) => {
    setcontactoOrigen(event.target.value);
  };
  
  const handleemailOrigenChange = (event) => {
    setemailOrigen(event.target.value);
  };

  const handledireccionOrigenChange = (event) => {
    setdireccionOrigen(event.target.value);
  };

  const handletelefonoOrigenChange = (event) => {
    settelefonoOrigen(event.target.value);
  };

  const handlenombreDestinoChange = (event) => {
    setnombreDestino(event.target.value);
  };

  const handlecontactoDestinoChange = (event) => {
    setcontactoDestino(event.target.value);
  };

  const handledireccionDestinoChange = (event) => {
    setdireccionDestino(event.target.value);
  };

  const handleemailDestinoChange = (event) => {
    setemailDestino(event.target.value);
  };

  const handletelefonoDestinoChange = (event) => {
    settelefonoDestino(event.target.value);
  };

  const handlecalleDestinoChange = (event) => {
    setcalleDestino(event.target.value);
  };

  const handlenumeroDestinoChange = (event) => {
    setnumeroDestino(event.target.value);
  };

  const handlecpDestinoChange = (event) => {
    setcpDestino(event.target.value);
  };

  const handlecoloniaDestinoChange = (event) => {
    setcoloniaDestino(event.target.value);
  };

  const handlealcaldiaDestinoChange = (event) => {
    setalcaldiaDestino(event.target.value);
  };

  const handlereferenciasDestinoChange = (event) => {
    setreferenciasDestino(event.target.value);
  };

  const handlecalleOrigenChange = (event) => {
    setcalleOrigen(event.target.value);
  };

  const handlenumeroOrigenChange = (event) => {
    setnumeroOrigen(event.target.value);
  };

  const handlecpOrigenChange = (event) => {
    setcpOrigen(event.target.value);
  };

  const handlecoloniaOrigenChange = (event) => {
    setcoloniaOrigen(event.target.value);
  };

  const handlealcaldiaOrigenChange = (event) => {
    setalcaldiaOrigen(event.target.value);
  };

  const handlereferenciasOrigenChange = (event) => {
    setreferenciasOrigen(event.target.value);
  };

  const handleproteccionChange = (event) => {
    setproteccion({
      ...protec,
      [event.target.name]: event.target.checked,
    });
  };

  const { protec } = setproteccion;

  const handlevalorChange = (event) => {
    setvalor(event.target.value);
  };
  
  const handlealturaChange = (event) => {
    setaltura(event.target.value);
    if(ancho != '' && altura != '' && largo != ''){  
      let peso1 =  ancho*altura*largo/500;
      setpeso(peso1);      
    }
  };
  
  const handleanchoChange = (event) => {
    setancho(event.target.value);
    if(ancho != '' && altura != '' && largo != ''){   
      let peso1 =  ancho*altura*largo/500;
      setpeso(peso1);       
    }
  };
  
  const handlelargoChange = (event) => {
    setlargo(event.target.value);
    if(ancho != '' && altura != '' && largo != ''){   
      let peso1 =  ancho*altura*largo/500;
      setpeso(peso1);      
    }
  };
  
  const handlepesoChange = (event) => {
    setpeso(event.target.value);
  };
  
  const handleproyectoChange = (event) => {
    setproyecto(event.target.value);
  };

  const handlesitioChange = (event) => {
    setsitio(event.target.value);
  };

function getEmpresas() {
  axios
  .post("https://boxerlogistica.com/api/getEmpresasTotal.php", {
    clienteid: clienteid
  })
  .then(function(response3){
    //const empresa = response3.data.data;
    //console.log(response3.data.data);
    setApiResponseEmp(response3.data.message);
    setEmpresa(response3.data.data); 

    const empresa3 = JSON.stringify(response3.data.data);

    const PedidoData2 = JSON.parse(empresa3);
    //console.log(PedidoData2[0].contactoOrigen);
  
    //console.log(empresa3);

    setcontactoOrigen(PedidoData2[0].contactoOrigen);
    setnombreOrigen(PedidoData2[0].nombreOrigen);
    setcontactoOrigen(PedidoData2[0].contactoOrigen);
    setemailOrigen(PedidoData2[0].emailOrigen);
    setdireccionOrigen(PedidoData2[0].direccionOrigen);
    settelefonoOrigen(PedidoData2[0].telefonoOrigen);
    setcalleOrigen(PedidoData2[0].calleOrigen);
    setnumeroOrigen(PedidoData2[0].numeroOrigen);
    setcpOrigen(PedidoData2[0].cpOrigen);
    setcoloniaOrigen(PedidoData2[0].coloniaOrigen);
    setalcaldiaOrigen(PedidoData2[0].alcaldiaOrigen);
    setreferenciasOrigen(PedidoData2[0].referenciasOrigen);
  }); 
}


  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post("https://boxerlogistica.com/api/Nuevo_Pedido.php", {
        nombreOrigen: nombreOrigen,
        contactoOrigen: contactoOrigen,
        direccionOrigen: direccionOrigen,
        emailOrigen: emailOrigen,
        telefonoOrigen: telefonoOrigen,
        nombreDestino: nombreDestino,
        contactoDestino: contactoDestino,
        direccionDestino: direccionDestino,
        emailDestino: emailDestino,
        telefonoDestino: telefonoDestino,
        clienteid: clienteid,
        calleDestino: calleDestino,
        numeroDestino: numeroDestino,
        cpDestino: cpDestino,
        coloniaDestino: coloniaDestino,
        alcaldiaDestino: alcaldiaDestino,
        referenciasDestino: referenciasDestino,
        calleOrigen: calleOrigen,
        numeroOrigen: numeroOrigen,
        cpOrigen: cpOrigen,
        coloniaOrigen: coloniaOrigen,
        alcaldiaOrigen: alcaldiaOrigen,
        referenciasOrigen: referenciasOrigen,
        proteccion: proteccion.proteccion,
        valor: valor,
        altura: altura,
        ancho: ancho,
        largo: largo,
        peso: peso,
        proyecto: proyecto,
        sitio: sitio
      })
      .then((response) => {
       // console.log(response);
        setApiResponse(response.data.status);
        //setNewPedidos(response.data.data);
        const lastid = response.data.data.lastid;
        const seguimientoID = response.data.data.seguimientoID;

        sessionStorage.setItem("lastid", lastid);
        sessionStorage.setItem("seguimientoID", seguimientoID);
       
        //console.log(lastid);
        //console.log(seguimientoID);
        if (response.data.status === "success") {
          //window.location.href = "/EnvioPaquete";
          window.location.href = "/EnvioCorrecto";
        }else{
          window.location.href = "/Envioerror";
        }
      })
      .catch((error) => {
        console.error(error);
        setApiResponse(error.response.data.message);
      });
  };



  return (

  <Container>
      <form onSubmit={handleSubmit}>
   {apiResponse && (
            <Alert
              style={{ marginBottom: "20px" }}
              severity={apiResponse.includes("success") ? "success" : "error"}
            >
              {apiResponse}
            </Alert>
          )}
      <div>
            <br></br>
            <br></br>
                        <Typography variant="h4" gutterBottom>
                            Ingresa tu dirección de origen (remitente) y la de destino (destinatario).
                        </Typography>
                            <br></br>  

          <div className="Inicio-envio">
            <div className="envio-container" >
                          <div className="div-left_envio">
                            <div className="envio">
                                  <div className="row">
                                        <div className="col-25">
                                          <label for="proyecto">*Proyecto:</label>
                                        </div>
                                        <div className="col-75">  
                                        <TextField
                                              type="text"
                                              required
                                              value={proyecto}
                                              onChange={handleproyectoChange}
                                              variant="filled"
                                              id="proyecto"
                                              name="proyecto"
                                              //label="Proyecto"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')} 
                                              style={{ marginBottom: "20px" }} />
                                        </div>
                                  </div>
                            </div>
                            <div className="envio">
                                    De:
                                   
                                    {empresa ? empresa.map((option2)  => ( 
                                    <>
                                    <div className="row">
                                        <div className="col-25">
                                          <label for="contactoOrigen">*Tu nombre:</label>
                                        </div>
                                        <div className="col-75">  
                                        <TextField
                                              type="text"
                                              required
                                              value={contactoOrigen}
                                              onChange={handlecontactoOrigenChange}
                                              variant="filled"
                                              id="contactoOrigen"
                                              name="contactoOrigen"
                                              //label="Contacto Origen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')} 
                                              style={{ marginBottom: "20px" }} />
                                        </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="nombreOrigen">Compañía: </label>
                                          </div>
                                          <div className="col-75">
                                        <TextField
                                            type="text"
                                            value={nombreOrigen}
                                            onChange={handlenombreOrigenChange}
                                            variant="filled"
                                            id="nombreOrigen"
                                            //label="Nombre Origen"
                                            fullWidth
                                            /*onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                            onInput={e => e.target.setCustomValidity('')}*/
                                            style={{ marginBottom: "20px" }} />  
                                          </div>
                                    </div>
                                    <div className="row">       
                                          <div className="col-25">,<span>Dirección: <br></br></span>
                                            <label for="calleOrigen">*Calle</label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="hidden"
                                              value={direccionOrigen}
                                              //defaultValue={option2.direccionOrigen}
                                              onChange={handledireccionOrigenChange}
                                              variant="filled"
                                              id="direccionOrigen"
                                              //label="Direccion Origen"
                                              fullWidth
                                              style={{ marginBottom: "20px" }} />

                                              <TextField
                                              type="text"
                                              value={calleOrigen}
                                              required
                                              onChange={handlecalleOrigenChange}
                                              variant="filled"
                                              id="calleOrigen"
                                              //label="Direccion Origen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="numeroOrigen">*Número:</label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={numeroOrigen}
                                              onChange={handlenumeroOrigenChange}
                                              variant="filled"
                                              id="numeroOrigen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="cpOrigen">*CP: </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={cpOrigen}
                                              onChange={handlecpOrigenChange}
                                              variant="filled"
                                              id="cpOrigen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="coloniaOrigen">*Colonia:  </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={coloniaOrigen}
                                              onChange={handlecoloniaOrigenChange}
                                              variant="filled"
                                              id="coloniaOrigen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="alcaldiaOrigen">*Alcaldía o Municipio: </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={alcaldiaOrigen}
                                              onChange={handlealcaldiaOrigenChange}
                                              variant="filled"
                                              id="alcaldiaOrigen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="referenciasOrigen">Referencias:  </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              value={referenciasOrigen}
                                              onChange={handlereferenciasOrigenChange}
                                              variant="filled"
                                              id="referenciasOrigen"
                                              multiline
                                              rows={4}
                                              fullWidth
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="emailOrigen">*Correo electrónico</label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={emailOrigen}
                                              onChange={handleemailOrigenChange}
                                              variant="filled"
                                              id="emailOrigen"
                                              //label="Email Origen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-25">
                                            <label for="telefonoOrigen">*Teléfono: </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={telefonoOrigen}
                                              onChange={handletelefonoOrigenChange}
                                              variant="filled"
                                              id="telefonoOrigen"
                                              //label="Telefono Origen"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                    </div></>  
                                         )) : null } 
                            </div>  
                        </div>
                        <div className="div-right_envio">
                            <div className="envio">
                                  <div className="row">
                                        <div className="col-25">
                                          <label for="sitio">Sitio:</label>
                                        </div>
                                        <div className="col-75">  
                                        <TextField
                                              type="text"
                                              value={sitio}
                                              onChange={handlesitioChange}
                                              variant="filled"
                                              id="sitio"
                                              name="sitio"
                                              //label="Sitio"
                                              fullWidth
                                              style={{ marginBottom: "20px" }} />
                                        </div>
                                  </div>
                            </div>
                            <div className="envio">
                                 Para:
                                <div className="row">
                                      <div className="col-25">
                                         <label for="contactoDestino">*Nombre del destinatario: </label>
                                      </div>
                                      <div className="col-75">
                                          <TextField
                                             type="text"
                                             value={contactoDestino}
                                             required
                                             onChange={handlecontactoDestinoChange}
                                             variant="filled"
                                             id="contactoDestino"
                                             //label="contactoDestino"
                                             fullWidth
                                             onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                             onInput={e => e.target.setCustomValidity('')}
                                             style={{ marginBottom: "20px" }}
                                          />
                                      </div>
                                </div>
                                <div className="row">
                                      <div className="col-25">
                                          <label for="nombreDestino">Compañía: </label>
                                      </div>
                                      <div className="col-75">
                                         <TextField
                                            type="text"
                                            value={nombreDestino}
                                            onChange={handlenombreDestinoChange}
                                            variant="filled"
                                            id="nombreDestino"
                                            //label="nombreDestino"
                                            fullWidth
                                            style={{ marginBottom: "20px" }}
                                         />
                                      </div>
                                </div>                                 
                                <div className="row">
                                      <div className="col-25"><span >Dirección: <br></br></span>
                                         <label for="direccionDestino">*Calle</label>
                                      </div>
                                      <div className="col-75">
                                      <TextField
                                            type="hidden"
                                            value={direccionDestino}
                                            onChange={handledireccionDestinoChange}
                                            variant="filled"
                                            id="direccionDestino"
                                            //label="direccionDestino"
                                            fullWidth
                                            style={{ marginBottom: "20px" }}
                                         />
                                         <TextField
                                            type="text"
                                            required
                                            value={calleDestino}
                                            onChange={handlecalleDestinoChange}
                                            variant="filled"
                                            id="calleDestino"
                                            //label="direccionDestino"
                                            fullWidth
                                            onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                            onInput={e => e.target.setCustomValidity('')}
                                            style={{ marginBottom: "20px" }}
                                         />
                                      </div>
                                </div>
                                <div className="row">
                                          <div className="col-25">
                                            <label for="numeroDestino">*Número:</label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={numeroDestino}
                                              //defaultValue={numeroDestino}
                                              onChange={handlenumeroDestinoChange}
                                              variant="filled"
                                              id="numeroDestino"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                </div>
                                <div className="row">
                                          <div className="col-25">
                                            <label for="cpDestino">*CP: </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={cpDestino}
                                              //defaultValue={option2.cpDestino}
                                              onChange={handlecpDestinoChange}
                                              variant="filled"
                                              id="cpDestino"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                </div>
                                <div className="row">
                                          <div className="col-25">
                                            <label for="coloniaDestino">*Colonia:  </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={coloniaDestino}
                                              //defaultValue={option2.coloniaDestino}
                                              onChange={handlecoloniaDestinoChange}
                                              variant="filled"
                                              id="coloniaDestino"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                </div>
                                <div className="row">
                                          <div className="col-25">
                                            <label for="alcaldiaDestino">*Alcaldía o Municipio: </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              required
                                              value={alcaldiaDestino}
                                              //defaultValue={option2.alcaldiaDestino}
                                              onChange={handlealcaldiaDestinoChange}
                                              variant="filled"
                                              id="alcaldiaDestino"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                </div>
                                <div className="row">
                                          <div className="col-25">
                                            <label for="referenciasDestino">Referencias:  </label>
                                          </div>
                                          <div className="col-75">
                                            <TextField
                                              type="text"
                                              value={referenciasDestino}
                                              //defaultValue={option2.referenciasDestino}
                                              onChange={handlereferenciasDestinoChange}
                                              variant="filled"
                                              id="referenciasDestino"
                                              multiline
                                              rows={4}
                                              fullWidth
                                              style={{ marginBottom: "20px" }} />
                                          </div>
                                </div>
                                <div className="row">
                                      <div className="col-25">
                                         <label for="emailDestino">*Correo electrónico: </label>
                                      </div>
                                      <div className="col-75">
                                         <TextField
                                            type="text"
                                            required
                                            value={emailDestino}
                                            onChange={handleemailDestinoChange}
                                            variant="filled"
                                            id="emailDestino"
                                            //label="emailDestino"
                                            fullWidth
                                            onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                            onInput={e => e.target.setCustomValidity('')}
                                            style={{ marginBottom: "20px" }}
                                         />
                                      </div>
                                </div>
                                <div className="row">
                                       <div className="col-25">
                                          <label for="telefonoDestino">*Teléfono: </label>
                                       </div>
                                       <div className="col-75">
                                          <TextField
                                              type="text"
                                              required
                                              value={telefonoDestino}
                                              onChange={handletelefonoDestinoChange}
                                              variant="filled"
                                              id="telefonoDestino"
                                              //label="telefonoDestino"
                                              fullWidth
                                              onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                              onInput={e => e.target.setCustomValidity('')}
                                              style={{ marginBottom: "20px" }}
                                          />
                                       </div>
                                </div>     
                            </div>               
                        </div>    
            </div>
            <div className="envio-container-right">
                <div className="div-right_paquete">
                                   <div className="row">
                                      Dimensión del articulo
                                   </div>
                                   <div className="row">
                                          <TextField
                                            type="text"
                                            required
                                            value={largo}
                                            onChange={handlelargoChange}
                                            variant="filled"
                                            id="largo"
                                            name="largo"
                                            //label="largo(cm)"
                                            helperText="largo(cm)*"
                                            //fullWidth
                                            onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                            onInput={e => e.target.setCustomValidity('')} 
                                            style={{ marginBottom: "20px" }}
                                          />
                                    </div>
                                   <div className="row">
                                          <TextField
                                            type="text"
                                            required
                                            value={ancho}
                                            onChange={handleanchoChange}
                                            variant="filled"
                                            id="ancho"
                                            name="ancho"
                                            helperText="ancho(cm)*"
                                            //label="ancho(cm)"
                                            //fullWidth
                                            style={{ marginBottom: "20px" }}
                                          />
                                   </div>
                                  <div className="row">
                                          <TextField
                                            type="text"
                                            required
                                            value={altura}
                                            onChange={handlealturaChange}
                                            variant="filled"
                                            id="altura"
                                            name="altura"
                                            //label="alto(cm)"
                                            helperText="alto(cm)*"
                                            //fullWidth
                                            onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                            onInput={e => e.target.setCustomValidity('')} 
                                            style={{ marginBottom: "20px" }}
                                          />
                                  </div>
                                  <div className="row">
                                      <label>Peso del paquete </label> 
                                   </div>
                                   <div className="row">
                                              <TextField
                                                       type="text"
                                                        required
                                                        value={peso}
                                                        variant="filled"
                                                        id="peso"
                                                        //label="peso"
                                                        helperText="peso"
                                                        fullWidth
                                                        onChange={handlepesoChange}
                                                        onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                                        onInput={e => e.target.setCustomValidity('')} 
                                                        style={{ marginBottom: "20px" }}
                                                        InputProps={{
                                                          readOnly: true,
                                                        }}
                                                  />
                                   </div>
                                                                             
                </div> 
            </div>
            <div className="envio-container-right">
                   <div className="div-right_paquete1">
                        <div className="div-right_paquete3">
                         <span className="paquete_boxtxt">PARA LOS PAQUETES DEBE CAPTURAR COMO MINIMO 1 CM O SU VALOR REAL EN EL CAMPO ANCHO
RDD (RETORNO DE DOCUMENTO) SE CONSIDERA COMO DOS ENVIOS
RDD APLICA PARA PAQUETES O SOBRES QUE SE ENVIEN PARA FIRMA Y REGRESAN A LAS INSTALACIONES DE IQVIA
EL MENSAJERO NO SERA RESPONSABLE POR PAQUETES DAÑADOS POR UN MAL EMBALAJE</span>
                        </div>
                   </div>
            </div>
            <div className="envio-container-right">
                   <div className="div-right_paquete2">
                         <img src="/images/box7.png" alt="Boxer Logistica Paquete" ></img>
                   </div>
            </div>
            <div className="envio-container-right">
                <div className="div-right_envio">
                  <Button variant="contained" type="submit">
                    Continuar
                  </Button>
                </div>
            </div>
          </div>
      </div>
     </form>
  </Container>          
  );
}

export default NuevoPedido;
